import { useEffect } from 'react'
import { message } from 'antd'
import { WARNING_MESSAGE } from '../../constants'
import authenticationStore from '../../stores/authenticationStore'

const useCheckPageAccessModule = ({
  history,
  moduleList,
  actionCode,
  childActionCode,
}) => {
  const { isSuperAdmin } = authenticationStore
  useEffect(() => {
    if (moduleList && moduleList.length) {
      const hasAccess = moduleList.some(
        action => action.code === actionCode && action.status === true
      )

      if (childActionCode !== undefined) {
        const hasAccessChild = moduleList.some(module =>
          module.sub_modules?.some(
            sub => sub.code === childActionCode && sub.status === true
          )
        )
        if (!isSuperAdmin) {
          if (!hasAccessChild) {
            message.error(WARNING_MESSAGE.ACCESS_PAGE, 3)
            history.push('/dashboard')
          }
        }
      }

      if (!hasAccess && !isSuperAdmin) {
        message.error(WARNING_MESSAGE.ACCESS_PAGE, 3)
        history.push('/dashboard')
      }
    }
  }, [moduleList, actionCode, history])
}

export default useCheckPageAccessModule
